export default {
  dark: 'Tamsus',
  light: 'Šviesa',
};
